export const constants = {
  responseTime: "do 24 hodin",
  foundedYear: 2005,
  openingHours: "Po–Pá 7:00–18:00, dle domluvy i víkend",
  phone: "+420 605 477 849",
  phoneRaw: "+420605477849",
  phoneHref: "tel:+420605477849",
} as const;
